import { handleErrorResponse } from '@/error/handleErrorResponse';
import { axiosInstance } from '@/utils/axiosInstance';

const ERROR_SERVICE_NAME_PREFIX = '[BACKGROUND_CHECK]';

export const validateDocumentService = async ({
  sdkToken,
  hash,
  method,
  flowIdentifier,
}: {
  sdkToken?: string;
  hash: string;
  method: 'POST' | 'GET';
  flowIdentifier?: string;
}) => {
  try {
    const headers = {
      'Accept-Language': 'pt-BR',
      'Content-Type': 'application/json',
      Accept: '*/*',
    };

    const requestOptions: any = {
      method,
      url: `${process.env.NEXT_PUBLIC_API_PRO}/documents/validation`,
      headers,
      params: { hash },
    };

    if (method === 'POST') {
      if (!sdkToken) {
        throw handleErrorResponse({
          error: 'sdkToken é obrigatório para requisições POST',
          prefix: ERROR_SERVICE_NAME_PREFIX,
        });
      }

      requestOptions.data = { sdk_token: sdkToken, flow_identifier: flowIdentifier };
    }

    const response = await axiosInstance(requestOptions, false);
    return response;
  } catch (error) {
    throw handleErrorResponse({
      error,
      prefix: ERROR_SERVICE_NAME_PREFIX,
    });
  }
};
